export const useCheckoutStore = defineStore('checkout', () => {
  // Estado reactivo para los datos del checkout
  const checkoutData = ref<CheckoutData | null>(null)
  
  // Estado para indicar si los datos están listos
  const isDataReady = ref(false)
  
  // Función para establecer los datos del checkout
  const setCheckoutData = (data: CheckoutData) => {
    checkoutData.value = data
    isDataReady.value = true
    
    // Persistir temporalmente en sessionStorage para mantener datos durante navegación
    if (process.client) {
      sessionStorage.setItem('checkout_data', JSON.stringify(data))
    }
  }
  
  // Función para obtener los datos del checkout
  const getCheckoutData = (): CheckoutData | null => {
    // Si no hay datos en memoria, intentar recuperar de sessionStorage
    if (!checkoutData.value && process.client) {
      const storedData = sessionStorage.getItem('checkout_data')
      if (storedData) {
        try {
          const parsedData = JSON.parse(storedData)
          checkoutData.value = parsedData
          isDataReady.value = true
        } catch (error) {
          console.error('Error parsing stored checkout data:', error)
          clearCheckoutData()
        }
      }
    }
    
    return checkoutData.value
  }
  
  // Función para limpiar los datos del checkout
  const clearCheckoutData = () => {
    checkoutData.value = null
    isDataReady.value = false
    
    if (process.client) {
      sessionStorage.removeItem('checkout_data')
    }
  }
  
  // Función para verificar si hay datos válidos
  const hasValidData = (): boolean => {
    const data = getCheckoutData()
    return data !== null && !!data.hotelId && !!data.roomId && !!data.totalAmount
  }
  
  // Función para actualizar un campo específico
  const updateCheckoutField = <K extends keyof CheckoutData>(field: K, value: CheckoutData[K]) => {
    if (checkoutData.value) {
      checkoutData.value[field] = value
      
      // Actualizar también en sessionStorage
      if (process.client) {
        sessionStorage.setItem('checkout_data', JSON.stringify(checkoutData.value))
      }
    }
  }
  
  return {
    checkoutData: readonly(checkoutData),
    isDataReady: readonly(isDataReady),
    setCheckoutData,
    getCheckoutData,
    clearCheckoutData,
    hasValidData,
    updateCheckoutField
  }
}) 